import { useEffect, useRef, useState } from "react";
import { AlertCircle, X } from "lucide-react";

const GlobalAlert = () => {
  const nativeAlertRef = useRef(null);
  const [alertData, setAlertData] = useState(null);

  useEffect(() => {
    nativeAlertRef.current = window.alert;

    // Pick a sensible title based on the message so confirmations don't all
    // read "Action needed". Callers may also pass an explicit title via
    // window.alert(message, { title }).
    const deriveTitle = (message) => {
      const text = String(message || "").toLowerCase();
      if (
        /\b(success|successfully|updated|created|saved|completed|sent|done)\b/.test(
          text,
        )
      ) {
        return "Success";
      }
      if (/\b(error|failed|invalid|unable|cannot|can't|wrong)\b/.test(text)) {
        return "Something went wrong";
      }
      return "Notice";
    };

    window.alert = (message, options = {}) => {
      setAlertData({
        title: options.title || deriveTitle(message),
        message: String(message || ""),
      });
    };

    return () => {
      if (nativeAlertRef.current) {
        window.alert = nativeAlertRef.current;
      }
    };
  }, []);

  if (!alertData) return null;

  const closeAlert = () => setAlertData(null);

  return (
    <div
      className="admin-modal-overlay"
      style={{ zIndex: 5000 }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="global-alert-title"
      onClick={closeAlert}
    >
      <div
        className="admin-modal"
        style={{ maxWidth: "420px", borderRadius: "28px" }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="admin-modal-header border-0 pb-0">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-orange-50 text-orange-500">
              <AlertCircle className="h-5 w-5" />
            </div>
            <h2
              id="global-alert-title"
              className="text-lg font-bold text-slate-900"
            >
              {alertData.title}
            </h2>
          </div>
          <button
            type="button"
            onClick={closeAlert}
            className="admin-modal-close"
            aria-label="Close alert"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="admin-modal-body pt-5 text-center">
          <p className="text-sm leading-6 text-slate-600">
            {alertData.message}
          </p>
        </div>

        <div className="admin-modal-footer border-0 pt-0">
          <button
            type="button"
            onClick={closeAlert}
            className="admin-btn admin-btn-primary min-w-[96px] justify-center"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalAlert;
